import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getProductSiblings(params) {
    let { baseUrl, brandId, country, partNumbers, options, uberToken, clientId, clientSecret } = params;
    invariant(baseUrl, 'baseUrl is a required param of getProductSiblings()');
    invariant(brandId, 'brandId is a required param of getProductSiblings()');
    invariant(country, 'country is a required param of getProductSiblings()');
    invariant(clientId, 'clientId is a required param of getProductSiblings()');
    invariant(partNumbers, 'partNumbers is a required param of getProductSiblings()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const partNumbersQuery = partNumbers ? `partNumbers=${partNumbers.join(',')}` : '';
    const optionalQuery = options ? `&${querystring.stringify(options)}` : '';

    const concatUrl = `${baseUrl}api/siblings/${localisedBrand}/v1/productVariants?${partNumbersQuery}${optionalQuery}`;

    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getProductSiblings');
}
